import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import CardWitTitle from './CardWithTitle';

function ApplicationIdentityDocuments({
  identityDocumentURL,
  selfieURL,
  submission,
  onChange,
  ...props
}) {

  const handleChange = (event) => {
    const name = event.target.name;
    let key = null;
    const value = event.target.checked;
    switch (name) {
      case 'approve-identity':
        key = 'approveIdentity';
      default:
        break;
    }
    const _submission = {
      ...submission,
      [key]: value,
    };
    onChange(_submission);
  };

  const useStyles = makeStyles(theme => ({
    photo: {
      width: '100%',
      padding: 20
    }
  }));

  const classes = useStyles();

  return (
    <React.Fragment>
      <CardWitTitle title="Verifiera identitet" onChange={handleChange} checked={submission?.approveIdentity} name='approve-identity'>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <a href={identityDocumentURL} target='_blank'><img src={identityDocumentURL} className={classes.photo} /></a>
          </Grid>
          <Grid item xs={6}>
            <a href={selfieURL} target='_blank'><img src={selfieURL} className={classes.photo} /></a>
          </Grid>
        </Grid>
      </CardWitTitle>
    </React.Fragment>
  );
}



export default ApplicationIdentityDocuments;